import { Component } from '@angular/core';
// import { ToastService } from './typescripts/pro/alerts';
import * as firebase from 'firebase';
//import { environment } from '../environments/environment';
import 'firebase/firestore';
import 'firebase/auth';
import { TranslateService } from '@ngx-translate/core';
import {AppConfigService} from './app.config'

@Component({
  selector: 'mdb-root',
  templateUrl: 'app.component.html',
  //styleUrls: ['../../scss/angular/mdb-angular.scss','app.component.scss']
  styleUrls: ['app.component.scss']
})

export class AppComponent {
  constructor(translate: TranslateService, appConfigService: AppConfigService){
    //firebase.initializeApp(environment.firebase);
    firebase.initializeApp(appConfigService.getFirebase())
    translate.setDefaultLang('es');
    translate.use('es');
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts